import { EmailOutlineIcon } from '@change/ds-icons/EmailOutlineIcon';
import { FacebookIcon } from '@change/ds-icons/FacebookIcon';
import { FacebookMessengerIcon } from '@change/ds-icons/FacebookMessengerIcon';
import { InstagramIcon } from '@change/ds-icons/InstagramIcon';
import { LineIcon } from '@change/ds-icons/LineIcon';
import { LinkIcon } from '@change/ds-icons/LinkIcon';
import { NextDoorIcon } from '@change/ds-icons/NextDoorIcon';
import { RedditIcon } from '@change/ds-icons/RedditIcon';
import { ShareIcon } from '@change/ds-icons/ShareIcon';
import { SmsIcon } from '@change/ds-icons/SmsIcon';
import { TikTokIcon } from '@change/ds-icons/TikTokIcon';
import { TwitterIcon } from '@change/ds-icons/TwitterIcon';
import { VkIcon } from '@change/ds-icons/VkIcon';
import { WhatsAppIcon } from '@change/ds-icons/WhatsAppIcon';

import type { ShareChannelButtonChannel } from './types';

export const ICON_BY_CHANNEL: Readonly<Record<ShareChannelButtonChannel, React.ReactNode>> = {
	instagramStories: <InstagramIcon />,
	facebook: <FacebookIcon />,
	facebookMessenger: <FacebookMessengerIcon />,
	twitter: <TwitterIcon />,
	whatsapp: <WhatsAppIcon />,
	instagram: <InstagramIcon />,
	vk: <VkIcon />,
	line: <LineIcon />,
	nextdoor: <NextDoorIcon />,
	email: <EmailOutlineIcon />,
	sms: <SmsIcon />,
	copy: <LinkIcon />,
	mobileNativeShare: <ShareIcon />,
	reddit: <RedditIcon />,
	tiktok: <TikTokIcon />,
};
